import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
import ChatActions from 'chat/actions/ChatActions';
import Copy from 'components/Copy';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import RelationshipActions from 'actions/RelationshipActions';

type Props = {
  memberId: number;
  memberName: string;
  blocked?: boolean;
  disabled?: boolean;
  chatUUID?: string;
};

export default class BlockMemberMenuItem extends React.Component<Props> {
  blockMember = (): void => {
    const { memberId, memberName, chatUUID } = this.props;
    //
    RelationshipActions.block(memberId, memberName).then(() => {
      if (chatUUID) {
        ChatActions.loadChat(chatUUID);
      }
    });
  };

  unblockMember = (): void => {
    const { memberId, memberName, chatUUID } = this.props;
    //
    RelationshipActions.unblock(memberId, memberName).then(() => {
      if (chatUUID) {
        ChatActions.loadChat(chatUUID);
      }
    });
  };

  renderConfirmDialog() {
    const { memberName } = this.props;

    const subtext = (
      <Copy color="graphite">
        When you remove {memberName || 'them'},
        <ul>
          <li>
            You will no longer have access to their message history. Please{' '}
            <Link target="_blank" href={LinkConstants.PARTICIPANT_MESSAGE_HISTORY}>
              send their message history to yourself
            </Link>{' '}
            before completing this action.
          </li>
          <li>
            You will also no longer be able to direct message or add them to your classes. They will
            still be able to join classes owned by you unless you{' '}
            <Link target="_blank" href={LinkConstants.CLASS_CODES}>
              change the class code.
            </Link>
          </li>
        </ul>
      </Copy>
    );
    return (
      <ConfirmDialog
        eventScreenName="BlockMemberMenuItem"
        actionButtonText="Block"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.blockMember}
        title={`Block ${memberName}?`}
        subtext={subtext}
      />
    );
  }

  render() {
    if (this.props.blocked) {
      return (
        <MenuItem
          data-testid={`conversation-sidebar-participant-menu-unblock-${this.props.memberId}`}
          onClick={this.unblockMember}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-unblock-${this.props.memberId}`}
        >
          <Glyph name="disabled" />
          <span>Unblock user</span>
        </MenuItem>
      );
    } else {
      return (
        <ModalMenuItem
          data-testid={`conversation-sidebar-participant-menu-block-${this.props.memberId}`}
          modal={this.renderConfirmDialog()}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-block-${this.props.memberId}`}
        >
          <Glyph name="disabled" />
          <span>Block user</span>
        </ModalMenuItem>
      );
    }
  }
}
